<template>
  <v-card>
    <div class="d-flex pa-9">
      <div>
        <img
          :src="marketingManager.avatar_url"
          data-testid="mm-avatar"
          class="rounded-circle"
          height="100"
        />
      </div>
      <div class="pl-9 py-3 w-100">
        <div>
          <div class="text-subtitle-1">Marketing Manager</div>
          <h2 class="text-h4 mb-3" data-testid="mm-name">
            {{ marketingManager.name }}
          </h2>

          <card-items
            :items="items"
            class="w-100 ma-n3"
            xl="12"
            lg="12"
            md="12"
            sm="12"
            xs="12"
            cols="12"
          />
        </div>
      </div>
    </div>

    <v-card-actions class="w-100">
      <app-button
        block
        color="primary"
        class="text-none"
        :href="href"
        data-testid="mm-scheduling-link"
        target="_blank"
      >
        {{ title }} <v-icon :icon="mdiChevronRight" />
      </app-button>
    </v-card-actions>
  </v-card>
</template>

<script setup>
import CardItems from "@/components/shared/card-items/CardItems.vue";

import { useUserStore } from "@/stores/user";
import { linkItem } from "@/components/shared/card-items/card-items";
import { mdiChevronRight } from "@mdi/js";

const props = defineProps({
  title: { type: String, required: true },
  href: { type: String, required: true }
});

const user = useUserStore();

const marketingManager = user.loginable.marketing_manager;

const items = [];

if (marketingManager.phone_work) {
  const phone = marketingManager.phone_work;
  items.push(
    linkItem({
      title: "Phone",
      href: `tel:${phone}`,
      text: phone,
      dataOutboundId: marketingManager.id,
      dataOutboundType: "MarketingManager",
      dataOutboundNumber: phone
    })
  );
}

if (marketingManager.email) {
  const email = marketingManager.email;
  items.push(
    linkItem({
      title: "Email",
      href: `mailto:${email}`,
      text: email
    })
  );
}
</script>
